import { NgModule } from '@angular/core';
import { AdminLayoutModule } from './admin/admin-layout.module';
import { BasicLayoutModule } from './basic/basic-layout.module';

@NgModule({
  imports: [AdminLayoutModule, BasicLayoutModule],
  exports: [AdminLayoutModule, BasicLayoutModule]
})
export class LayoutsModule {}
